import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneFormat', standalone: false })
export class PhoneFormatterPipe implements PipeTransform {
  transform(phone: string | number | null): string {
    if (!phone) {
      return '';
    }

    let Phone = String(phone);

    return Phone.replace(/(\d{1,3})?(\d{1,3})?(\d{1,2})?(\d{1,2})?/, '+7 $1 $2-$3-$4');
  }
}
